module.exports = __webpack_public_path__ + "img/aboutus-title.6d64a3f3.png";